// Component here uses ES6 destructuring syntax in import, what is means is "retrieve the property 'Component' off of the object exported from the 'react'"
import React, {Component, PropTypes} from 'react';

// utility
import _ from 'lodash';
import cx from 'classnames';

import prettyPhone from '../../../../lib/prettyPhone';
import localDate from '../../../../lib/localDate';
import emailLink from '../../../../lib/emailLink';

import Pager from 'rc-pager';
import PreviousIcon from '../../../../common/svgs/PreviousIcon';
import NextIcon from '../../../../common/svgs/NextIcon';

import ChevronIcon from '../../../../common/svgs/ChevronIcon';



// lib
import {Table, TableBody, TableHeader, TableHeaderColumn, TableRow, TableRowColumn} from 'material-ui/Table';

class ApplicantsTable extends Component {
  static propTypes = {
    applicantGroup: PropTypes.object.isRequired,
    expandCard: PropTypes.func,
    qualifyingSpecialists: PropTypes.object,
    applicantStatusKeyedByName: PropTypes.object,
    OnPageChange: PropTypes.func,
    total: PropTypes.any,
    navColumnState: PropTypes.any,
    currentPage: PropTypes.number,
    pageSize: PropTypes.number,
  }

  constructor(props, context) {
    super(props, context);
    this.sortColumn = ::this.sortColumn;
    const initialState = {
      isFlipped: false,
      qualifyingSpecialists: _.keyBy(this.props.qualifyingSpecialists, 'employeeId'),
      sortBy: {
        by: 'id',
        order: 'desc'
      }
    };

    this.state = initialState;
  }

  flipColumn() {
    this.setState({
      isFlipped: !this.state.isFlipped
    });
  }

  handleSkip(currentPage) {
    if (this.props.OnPageChange) {
      this.props.OnPageChange(this.props.navColumnState, currentPage, this.props.pageSize, this.state.sortBy);
    }
  }

  sortColumn(columnName) {
    const newState = _.merge(this.state, {
      sortBy: {
        by: columnName,
        order: this.state.sortBy.by === columnName && this.state.sortBy.order === 'desc' ? 'asc' : 'desc' }
      }
    );

    this.setState(newState);

    if (this.props.OnPageChange) {
      this.props.OnPageChange(this.props.navColumnState, this.props.currentPage, this.props.pageSize, newState.sortBy);
    }
  }

  render() {
    const {
      applicantGroup,
      expandCard,
      total,
    } = this.props;

    let currentCount = this.props.pageSize * (this.props.currentPage + 1);
    currentCount = (currentCount < total) ? currentCount : total;

    let applicants = _.get(applicantGroup, 'data.items', []);

    let applicantsComponentArr =  _(applicants)
          .map((applicant) => {
            // const qualifyingSpecialist = _.get(this.state.qualifyingSpecialists, applicant.profile.qualifyingSpecialistId, {});
            const { color, label, lifespan } = _.get(this.props.applicantStatusKeyedByName, applicant.profile.applicantStatus.name, {});

            // this will be a prop
            const transparentPct = _.isNil(lifespan) ? 1 : ((lifespan > 0) ? 1 - ((+new Date() - +new Date(applicant.profile.dateModified))/(lifespan * 60 * 60 * 1000)) : 0);
            const rgbaColor = `rgba(${
              _.chunk(color.slice(1), 2).map(stringArr => Number.parseInt(stringArr.join(''), 16)).join() // conversion from base 16
            },${transparentPct})`; // calculating opacity

            return (
            <TableRow className='applicant-row' key={`${applicant.user.email}`} data-id={`${applicant.user.email}`}>
              <TableRowColumn className='name' style={{paddingLeft: '7px'}}>
                <div className='expand-icon' onClick={expandCard.bind(this, applicant.profile.id)} />
                <div className='applicant-name' data-id='Name' onClick={expandCard.bind(this, applicant.profile.id, true)}>
                  {`${applicant.user.firstName} ${applicant.user.lastName}`}
                </div>
              </TableRowColumn>
              <TableRowColumn className='status' style={{paddingLeft: '12px'}}>
                <div className='status-circle' data-id='Status Icon'style={{backgroundColor: rgbaColor, borderColor: color, color: transparentPct < 0.25 ? color : '#fff'}}>{label || ''}</div>
                {applicant.profile.applicantStatus.name}
              </TableRowColumn>
              <TableRowColumn className='phone' style={{paddingLeft: '12px', width: '148px'}}>
                {prettyPhone(applicant.user.phoneNumber1)}
              </TableRowColumn>
              <TableRowColumn className='email' style={{paddingLeft: '12px', width: '200px'}}>
                {emailLink(applicant.user.email)}
              </TableRowColumn>
              <TableRowColumn className='availability' style={{paddingLeft: '12px', width: '140px'}}>
                {localDate(applicant.profile.availabilityDate)}
              </TableRowColumn>
              <TableRowColumn  className='applied-date' style={{paddingLeft: '12px', width: '107px'}}>
                {localDate(applicant.profile.dateCreated)}
              </TableRowColumn>
            </TableRow>);
          })
          .value();


    // flip if state says so
    if(this.state.isFlipped) {
      applicantsComponentArr.reverse();
    }

    return (
      <li className='applicants-column applicant-table' data-id='applicant-list'>
        <div className='pager-wrapper'>
          <div className='pager-info'>Showing <span className='count'>{currentCount}</span> of <span className='count'>{total}</span></div>
          <Pager
            total={Math.ceil(total / this.props.pageSize)}
            current={this.props.currentPage}
            onSkipTo={this.handleSkip.bind(this)}
            previousLabel={<div className='prev'><PreviousIcon/> PREV</div>}
            nextLabel={<div className='next'>NEXT <NextIcon/></div>}
          />
        </div>
        <Table
          selectable={false}
          multiSelectable={false}
          fixedHeader
          height={'calc(100vh - 286.5px)'}
        >
          <TableHeader
            displaySelectAll={false}
            adjustForCheckbox={false}
          >
            <TableRow>
              <TableHeaderColumn className='name' style={{paddingLeft: '7px'}}>Name</TableHeaderColumn>
              <TableHeaderColumn className='status' style={{paddingLeft: '12px'}}>Status</TableHeaderColumn>
              <TableHeaderColumn className='phone' style={{paddingLeft: '12px', width: '148px'}}>Phone #</TableHeaderColumn>
              <TableHeaderColumn className='email' style={{paddingLeft: '12px', width: '200px'}}>Email</TableHeaderColumn>
              <TableHeaderColumn
                className={cx('availabilityDate', {'wv-pointer': true})}
                style={{padding: '0px', width: '140px'}}
                >
                  <div onClick={() => this.sortColumn('availabilityDate')}>
                  Availability
                  <span className={cx('wv-chevron',
                    {active: this.state.sortBy.by === 'availabilityDate'},
                    {flipped: this.state.sortBy.by === 'availabilityDate' && this.state.sortBy.order === 'desc'})} >
                    <ChevronIcon/>
                  </span>
                </div>
              </TableHeaderColumn>
              <TableHeaderColumn className='applied-date' style={{paddingLeft: '12px', width: '107px'}}>Applied</TableHeaderColumn>
            </TableRow>
          </TableHeader>
          <TableBody
            displayRowCheckbox={false}
          >
            {applicantsComponentArr}
          </TableBody>
        </Table>
      </li>
    );
  }
}


export default ApplicantsTable;



// WEBPACK FOOTER //
// ./shared/react/r_AdminDashboard/r_ApplicantManager/c_ApplicantsTable/index.js